import React from 'react';
import { useTranslation } from 'react-i18next';

import { ManageContractsApp } from '../contractManagementContext';

import Button from '../../../Common/Button';
import Loading from '../../../Common/Loading';

type FooterProps = {
  formValid: boolean;
  formSubmitting: boolean;
};

export const Footer: React.FunctionComponent<FooterProps> = (props: FooterProps) => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { formPage } = ManageContractsApp.useState();
  const { formValid, formSubmitting } = props;

  return (
    <footer className="manage-contracts-footer">
      {formPage === 1 && (
        <Button
          className="buttonWhiteBack"
          onClick={(e): void => {
            e.preventDefault();
            dispatch(['changePage', formPage - 1]);
          }}
        >
          {t('manageContracts:manageContracts.FooterBackLink')}
        </Button>
      )}
      <Button
        type="submit"
        disabled={!formValid || formSubmitting}
        onClick={(e): void => {
          // @ts-ignore
          if (e.target.ariaDisabled !== 'false') {
            e.preventDefault();
          }
        }}
      >
        {formPage === 1 ? t('manageContracts:manageContracts.FooterOrderLink') : t('manageContracts:manageContracts.FooterSummaryLink')}
      </Button>
      {formSubmitting && <Loading size="small" />}
    </footer>
  );
};

export default Footer;
